import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["description", "renderedFiltersPanel", "renderedResultsCount", "renderedResultsFilters", "renderedSortDropdown", "resultsCount", "searchTerm", "title", "viewToggle"];
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Big } from 'foundations-components/transitional/components/Big';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { isValidElement, useMemo } from 'react';
import { MediaQueryView } from '../../layout/components/MediaQueryView';
import ResultsSection from './ResultsSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function StorefrontResultsHeader(_ref) {
  let {
      description,
      renderedFiltersPanel,
      renderedResultsCount: passedRenderedResultsCount,
      renderedResultsFilters,
      renderedSortDropdown,
      resultsCount,
      searchTerm,
      title,
      viewToggle
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const renderedResultsCount = useMemo(() => {
    if (passedRenderedResultsCount) return passedRenderedResultsCount;
    if (!resultsCount) return null;
    if ( /*#__PURE__*/isValidElement(resultsCount)) return resultsCount;
    const {
      start,
      end,
      total
    } = resultsCount;
    if (searchTerm) {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "marketplace-ui-common.storefront.resultsHeader.searchResultsCount",
        options: {
          start,
          end,
          count: total,
          searchTerm
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-ui-common.storefront.resultsHeader.resultsCount",
      options: {
        start,
        end,
        count: total
      }
    });
  }, [passedRenderedResultsCount, resultsCount, searchTerm]);
  return /*#__PURE__*/_jsxs(View, Object.assign({}, restProps, {
    children: [/*#__PURE__*/_jsx(MediaQueryView, {
      max: "sm",
      children: /*#__PURE__*/_jsx(ResultsSection, {
        gutterSize: "sm",
        children: renderedResultsFilters
      })
    }), title && /*#__PURE__*/_jsx(ResultsSection, {
      gutterSize: "sm",
      children: /*#__PURE__*/_jsx(Text, {
        as: "h1",
        "aria-level": 1,
        "data-selenium-id": "storefront-results-header-title",
        typography: "heading-500",
        children: title
      })
    }), description && /*#__PURE__*/_jsx(ResultsSection, {
      children: /*#__PURE__*/_jsx(Big, {
        children: description
      })
    }), /*#__PURE__*/_jsx(ResultsSection, {
      "data-test-id": "desktop-controls",
      gutterSize: "xs",
      children: /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        justify: "between",
        wrap: "wrap",
        children: [/*#__PURE__*/_jsx(Big, {
          children: renderedResultsCount
        }), /*#__PURE__*/_jsxs(MediaQueryView, {
          min: "sm",
          children: [viewToggle, renderedSortDropdown]
        })]
      })
    }), (renderedFiltersPanel || renderedSortDropdown) && /*#__PURE__*/_jsx(MediaQueryView, {
      max: "xs",
      children: /*#__PURE__*/_jsxs(TFlex, {
        justify: "between",
        "data-test-id": "mobile-controls",
        marginBlockEnd: "200",
        children: [renderedFiltersPanel, renderedSortDropdown]
      })
    }), /*#__PURE__*/_jsx(MediaQueryView, {
      min: "sm",
      children: /*#__PURE__*/_jsx(ResultsSection, {
        gutterSize: "sm",
        children: renderedResultsFilters
      })
    })]
  }));
}